import React, {useContext, useEffect, useState} from "react";
import localization from 'assets/localization/localization';
import Layout from "../../../components/sales/layout/layout";
import CustomModal from "../../valetServices/modal";
import ConstantInput from "../../../components/sales/Input/constantInput/constantInput";
import FileUpload from "../../../components/sales/fileUpload/fileUpload";
import Images from "../../../assets/images/imageData";
import TextAreaInput from "../../../components/sales/Input/textAreaInput/textAreaInput";
import {Button} from "react-bootstrap";
import {BaseUrl} from "contexts/baseUrl/baseUrl";

const AddToExternal = ({
                           documentUploadUrlPublic,
                           documentUrlDataPublic,
                           addMoney,
                           match,
                           addedMoney = [],
                           history
                       }) => {

    const {baseUrl} = useContext(BaseUrl);
    const [isLoading, setIsLoading] = useState(false);
    const [count, setCount] = useState(0)
    const [inputList, setInputList] = useState([{
        amount: "",
        remark: "",
        type: "",
        utr_no: "",
        wallet_type: "",
        wallet_id: '',
        role_id:''
    }])
    const [inputImage, setImageList] = useState([{url: ""}]);

    const handleImageAdd = () => {
        setImageList(
            [
                ...inputImage, {
                url: ''
            }
            ]
        )
    }

    const handleImageRemove = index => {
        const list = [...inputImage];
        list.splice(index, 1);
        setImageList(list);
    }

    const saveImage = (val, index) => {
        const list = [...inputImage]
        list[index]['url'] = val
        setImageList([...list])
    }

    const handleInputList = (val, key) => {
        let list = [...inputList]
        list[0][key] = val
        setInputList(list)
    }


    const handleSubmit = async () => {

        let list = [...inputList]
        list[0]['doc'] = inputImage
        list[0]['wallet_id'] = match?.params?.wallet_id
        list[0]['wallet_type'] = 'PARTNER'
        list[0]['role_id'] = localStorage.getItem('fusion-role')
        //console.log(list[0]);
        setIsLoading(true)
        await addMoney(list[0])
        setIsLoading(false)
        setCount(count + 1)
    }
    return (
        <>
            <Layout
                title={localization.wallet}
                isLoading={isLoading}
                isGoback={true}
            >
                <div className="container-fluid">
                    <div className="card">
                        {addedMoney !== null && addedMoney?.response?.status !== 200 &&
                            <CustomModal msg={addedMoney?.response?.message} click={count}/>}
                        {addedMoney !== null && addedMoney?.response?.status === 200 &&
                            <CustomModal msg={addedMoney?.response?.message} isPageLoad={true}
                                         click={count}
                                         url={`${baseUrl}/external-wallet-list`} history={history}/>}
                        <div className="card-header">
                            {localization.addWalletMoney}
                        </div>
                        <div className="card-body">
                            <div className="row">
                                <div className="col-sm-6">
                                    <ConstantInput
                                        label={localization.amount}
                                        value={""}
                                        type="number"
                                        handleChange={(val) =>
                                            handleInputList(val, 'amount')
                                        }
                                        required={true}
                                        isStarRequired={true}
                                    />
                                </div>
                                <div className="col-sm-6">
                                    <ConstantInput
                                        label={'UTR Cheque No'}
                                        value={""}
                                        type="text"
                                        handleChange={(val) =>
                                            handleInputList(val, 'utr_no')
                                        }
                                        //required={true}
                                    />
                                </div>
                                <div className="col-sm-12">
                                    <TextAreaInput
                                        inputValue={inputList[0].remark}
                                        rows={4}
                                        type="text"
                                        label={localization.remark}
                                        required
                                        isStarRequired={true}
                                        handleChange={(e) => handleInputList(e.target.value, 'remark')}
                                        value={inputList[0].remark}
                                    />
                                </div>
                                {inputImage.map((xx, i) => {
                                    return (
                                        <>
                                            <div className="col-sm-6">
                                                <FileUpload
                                                    id={"addAttachment" + i}
                                                    accept=".pdf,.png,.jpg,.jpeg,.doc"
                                                    documentUploadUrl={documentUploadUrlPublic}
                                                    documentUrlData={documentUrlDataPublic}
                                                    onChange={(val) =>
                                                        saveImage(val, i)
                                                    }
                                                    prefilledFilename={xx?.url ? 'Image uploaded' : ""}
                                                >
                                                        <span className="btn btn-transparent">
                                                            {localization.image}
                                                        </span>
                                                </FileUpload>
                                            </div>
                                            {xx?.url &&
                                                <div className="col-md-2">
                                                    {
                                                        xx?.url.split('.').pop() === 'png' ? <img src={xx?.url} style={{
                                                                "width": "80px",
                                                                "borderRadius": "16px",
                                                                "height": "57px"
                                                            }}/> :
                                                            xx?.url.split('.').pop() === 'jpeg' ? <img src={xx?.url}
                                                                                                       style={{
                                                                                                           "width": "80px",
                                                                                                           "borderRadius": "16px",
                                                                                                           "height": "57px"
                                                                                                       }}/> :
                                                                xx?.url.split('.').pop() === 'jpg' ? <img src={xx?.url}
                                                                                                          style={{
                                                                                                              "width": "80px",
                                                                                                              "borderRadius": "16px",
                                                                                                              "height": "57px"
                                                                                                          }}/> :
                                                                    xx?.url.split('.').pop() === 'pdf' ?
                                                                        <img src={Images?.DocIcon} alt=""
                                                                             className="view-icon"/> :
                                                                        xx?.url.split('.').pop() === 'doc' ?
                                                                            <img src={Images?.DocIcon} alt=""
                                                                                 className="view-icon"/> :
                                                                            xx?.url.split('.').pop() === 'mp4' ?
                                                                                <video width="120" height="80" controls>
                                                                                    <source src={xx?.url}
                                                                                            type="video/mp4"></source>
                                                                                </video> :
                                                                                xx?.url.split('.').pop() === 'webm' ?
                                                                                    <video width="120" height="80"
                                                                                           controls>
                                                                                        <source src={xx?.url}
                                                                                                type="video/mp4"></source>
                                                                                    </video> :
                                                                                    xx?.url.split('.').pop() === 'mkv' ?
                                                                                        <video width="120" height="80"
                                                                                               controls>
                                                                                            <source src={xx?.url}
                                                                                                    type="video/mp4"></source>
                                                                                        </video> :
                                                                                        ""
                                                    }
                                                </div>
                                            }
                                            {inputImage.length !== 1 &&
                                                <div className="col-md-1">
                                                    <button
                                                        onClick={() => handleImageRemove(i)}
                                                        className="mr10 btn btn-sm btn-danger">Remove
                                                    </button>
                                                </div>
                                            }
                                            {inputImage.length - 1 === i &&
                                                <div className="col-md-2">
                                                    <button className="btn btn-sm btn-primary"
                                                            onClick={handleImageAdd}>Add
                                                    </button>
                                                </div>
                                            }
                                        </>
                                    );
                                })}
                                <div className="col-md-12">
                                    <center><Button onClick={handleSubmit}>
                                        {localization.submitDtl}
                                    </Button>
                                    </center>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </Layout>
        </>
    )
}

export default AddToExternal;